export enum Services {
    BusinesMeeting = 0,
    BirthdayCelebration = 1,
    DreamVocation = 2,
    LiveMusic = 3,
    Buffet = 4,
    HappyHour = 5,
    Celebration = 6,
    DreamVacation = 7,
    CasualMeetUp = 7,
    Date = 8,
    Birthday = 9,
    Anniversary = 10,
    Graduarion = 11,
    Holidays = 12,
    WorkPromotion = 13,
    WorkEvent = 14,
    BusinessMeeting = 15,
    MarriageProposal = 16,
    SportEvent = 17,
    CharityAuction = 18,
    DinnerShow = 19,
    Cars = 20,
    Scooters = 21,
    Tricycles = 22,
    Motorbikes = 23,
    Strollers = 24,
    CarSeats = 25,
    Sligshot = 26,
    SuperSportscars = 27,
    GPS = 28,
    FunwithFamily = 29,
    FunwithFriends = 30,
    VacationActivity = 31,
    Disney = 32,
    DisneySprings = 33,
    Epcot = 34,
    HollywoodStudios = 35,
    AnimalKingdom = 36,
    MagicKingdom = 37,
    TyphoonLagoon = 38,
    KennedySpaceCenter = 39,
    NASA = 40,
    PortCanaveral = 41,
    AirportsOrlandoMCO = 42,
    MiamiMIA = 43,
    Sanford = 44,
    FortLauderdale = 45,
    Universal = 46,
    UniversalCityWalk = 47,
    Islandofadventure = 48,
    VolcanoBay = 49,
    SeaWord = 50,
    Aquatica = 51,
    BuchGardens = 52,
    Legoland = 53,
    IconPark = 54,
    DiscoveryCove = 55,
    FunSpot = 56,
    Gatorland = 57,
    Dezerland = 58,
    InternationalDr = 59,
    AmwayCenterNBA = 60,
    CampingWord = 61,
    OrlandoCityMLS = 62,
    LakeEola = 63,
    Downtown = 64,
    WinterPark = 65,
    Spiderman = 66,
    Cinderella = 67,
    Ariel = 68,
    Elsa = 69,
    Anna = 70,
    IsabelaMadrigal = 71,
    MirabelMadrigal = 72,
    Bella = 73,
    Rapunzel = 74,
    SnowWhite = 75,
    Mickey = 76,
    Minnie = 77,
    Donald = 78,
    Daisy = 79,
    Pluto = 80,
    Goofy = 81,
    Orlando = 82,
    Miami = 83,
    Tampa = 84,
    MiamiBeach = 85,
    Clearwater = 86,
    CocoaBeach = 87,
    DaytonaBeach = 88
};

export const listServices = [
    { value: Services.BusinessMeeting, label: 'Business Meeting' },
    { value: Services.BirthdayCelebration, label: 'Birthday Celebration' },
    { value: Services.DreamVocation, label: 'Dream Vocation' },
    { value: Services.LiveMusic, label: "Live Music" },
    { value: Services.Buffet, label: "Buffet" },
    { value: Services.HappyHour, label: "Happy Hour" },
    { value: Services.Celebration, label: "Celebration" },
    { value: Services.DreamVacation, label: "Dream Vacation" },
    { value: Services.CasualMeetUp, label: "Casual Meet-up" },
    { value: Services.Date, label: "Date" },
    { value: Services.Birthday, label: "Birthday" },
    { value: Services.Anniversary, label: "Anniversary" },
    { value: Services.Graduarion, label: "Graduarion" },
    { value: Services.Holidays, label: "Holidays" },
    { value: Services.WorkPromotion, label: "Work Promotion" },
    { value: Services.WorkEvent, label: "Work Event" },
    { value: Services.BusinessMeeting, label: "Business Meeting" },
    { value: Services.MarriageProposal, label: "Marriage Proposal" },
    { value: Services.SportEvent, label: "Sport Event" },
    { value: Services.CharityAuction, label: "Charity Auction" },
    { value: Services.DinnerShow, label: "Dinner Show" },
    { value: Services.Cars, label: "Cars" },
    { value: Services.Scooters, label: "Scooters" },
    { value: Services.Tricycles, label: "Tricycles" },
    { value: Services.Motorbikes, label: "Motorbikes" },
    { value: Services.Strollers, label: "Strollers" },
    { value: Services.CarSeats, label: "Car Seats" },
    { value: Services.Sligshot, label: "Sligshot" },
    { value: Services.SuperSportscars, label: "Super Sportscars" },
    { value: Services.GPS, label: "GPS" },
    { value: Services.FunwithFamily, label: "Funwith Family" },
    { value: Services.FunwithFriends, label: "Funwith Friends" },
    { value: Services.VacationActivity, label: "Vacation Activity" },
    { value: Services.Disney, label: "Disney" },
    { value: Services.DisneySprings, label: "Disney Springs" },
    { value: Services.Epcot, label: "Epcot" },
    { value: Services.HollywoodStudios, label: "Hollywood Studios" },
    { value: Services.AnimalKingdom, label: "Animal Kingdom" },
    { value: Services.MagicKingdom, label: "Magic Kingdom" },
    { value: Services.TyphoonLagoon, label: "Typhoon Lagoon" },
    { value: Services.KennedySpaceCenter, label: "Kennedy Space Center NASA" },
    { value: Services.NASA, label: "NASA" },
    { value: Services.PortCanaveral, label: "Port Canaveral" },
    { value: Services.AirportsOrlandoMCO, label: "Airports Orlando MCO" },
    { value: Services.MiamiMIA, label: "Miami MIA" },
    { value: Services.Sanford, label: "Sanford" },
    { value: Services.FortLauderdale, label: "Fort Lauderdale" },
    { value: Services.Universal, label: "Universal" },
    { value: Services.UniversalCityWalk, label: "Universal City Walk" },
    { value: Services.Islandofadventure, label: "Island of adventure" },
    { value: Services.VolcanoBay, label: "Volcano Bay" },
    { value: Services.SeaWord, label: "SeaWord" },
    { value: Services.Aquatica, label: "Aquatica" },
    { value: Services.BuchGardens, label: "Buch Gardens" },
    { value: Services.Legoland, label: "Legoland" },
    { value: Services.IconPark, label: "Icon Park" },
    { value: Services.DiscoveryCove, label: "Discovery Cove" },
    { value: Services.FunSpot, label: "Fun Spot" },
    { value: Services.Gatorland, label: "Gatorland" },
    { value: Services.Dezerland, label: "Dezerland" },
    { value: Services.InternationalDr, label: "InternationalDr" },
    { value: Services.AmwayCenterNBA, label: "AmwayCenter NBA" },
    { value: Services.CampingWord, label: "Camping Word" },
    { value: Services.OrlandoCityMLS, label: "Orlando City MLS" },
    { value: Services.LakeEola, label: "Lake Eola" },
    { value: Services.Downtown, label: "Downtown" },
    { value: Services.WinterPark, label: "Winter Park" },
    { value: Services.Spiderman, label: "Spiderman" },
    { value: Services.Cinderella, label: "Cinderella" },
    { value: Services.Ariel, label: "Ariel" },
    { value: Services.Elsa, label: "Elsa" },
    { value: Services.Anna, label: "Anna" },
    { value: Services.IsabelaMadrigal, label: "Isabela Madrigal" },
    { value: Services.MirabelMadrigal, label: "Mirabel Madrigal" },
    { value: Services.Bella, label: "Bella" },
    { value: Services.Rapunzel, label: "Rapunzel" },
    { value: Services.SnowWhite, label: "SnowWhite" },
    { value: Services.Mickey, label: "Mickey" },
    { value: Services.Minnie, label: "Minnie" },
    { value: Services.Donald, label: "Donald" },
    { value: Services.Daisy, label: "Daisy" },
    { value: Services.Pluto, label: "Pluto" },
    { value: Services.Goofy, label: "Goofy" },
    { value: Services.Orlando, label: "Orlando" },
    { value: Services.Miami, label: "Miami" },
    { value: Services.Tampa, label: "Tampa" },
    { value: Services.MiamiBeach, label: "Miami Beach" },
    { value: Services.Clearwater, label: "Clearwater" },
    { value: Services.CocoaBeach, label: "Cocoa Beach" },
    { value: Services.DaytonaBeach, label: "Daytona Beach" },
];